// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3JnRx","container_memorial":"style__container_memorial___-gs0b","header":"style__header___16sX_","title":"style__title___1PS3e","profileAvatar":"style__profileAvatar___L9q09","memorialCandle":"style__memorialCandle___3ugtK","bgAnimation":"style__bgAnimation___wt1bN","mainAnimation":"style__mainAnimation___3ey1s","wowAnimation":"style__wowAnimation___2WM6I","backBtn":"style__backBtn___3wD5f"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/congratulations/style.css
// module id = 1190
// module chunks = 0